import { useContext } from "react";
import MagnetGroupContext from "./MagnetGroupContext";

const useMagnetGroups = () => {
    return useContext(MagnetGroupContext);
}

export default useMagnetGroups;
